import styled from "@emotion/styled";
import { Box, Button, useTheme } from "@mui/material";
import { useWeb3React } from "@web3-react/core";
import moment from "moment";
import React, { useState } from "react";
import { addIcon } from "../../../assets";
import { onConfirmYieldDistribution } from "../../../contract";
import { scholarsList } from "../../../data/dummyScholars";
import { useUIActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { tokens } from "../../../theme";
import {
  getAccumulatedYield,
  getBorrowersForLender,
  getKeyForYieldClaim,
  getKeyForYieldClaimLender,
  onYieldDistribution,
} from "../../../utils/wallet/apiHelpers";
import { ScholarCard } from "./ScholarCard";
import ScholarTableView from "./ScholarTableView";

const AddScholarBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px 7px 15px 7px",
  backgroundColor: theme.palette.secondary.dark,
  width: "280px",
  height: "317px",
  border: "0.5px solid #6A27EA",
  borderRadius: 14,
  boxShadow: "0px 15px 30px rgba(118, 118, 118, 0.2)",
  position: "relative",
}));

const StyledButton = styled(Button)(({ theme, colors }) => ({
  backgroundColor: colors.whiteAccent[900],
  color: colors.primary[500],
  fontSize: "14px",
  fontWeight: 400,
  width: "272px",
  height: "40px",
  borderRadius: "7px",
  borderColor: colors.primary[500],
  marginLeft: "20px",
  "&:hover": {
    backgroundColor: colors.primary[600],
    borderColor: colors.primary[500],
    color: colors.whiteAccent[900],
  },
}));

export const ScholarDetails = ({
  view,
  NftBoxProps,
  setOpen,
  scholarsToRender,
  searchShow,
  filtered,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { account } = useWeb3React();
  const { scholars } = useTypedSelector((state) => state.apiReducer);
  const { setLoading, setSnackbar } = useUIActions();
  const [scholarSelected, setScholarSelected] = useState("");

  const onClaimCallback = async (msg, status) => {
    setLoading(false);
    setSnackbar({
      open: true,
      severity: status ? "success" : "error",
      message: msg,
    });
    setScholarSelected("");
  };

  const yieldDistribute = async (encKey, borrower, rewardTokenAddress) => {
    try {
      const resp = await getKeyForYieldClaimLender(encKey, account);
      console.log("resp for key", resp);
      const finalResp = await onYieldDistribution(
        resp,
        account.toLowerCase(),
        borrower.toLowerCase(),
        rewardTokenAddress.toLowerCase()
      );
      console.log("finalResp", finalResp);
      return finalResp;
    } catch (e) {
      console.log("yielddistribute error", e);
      return false;
    }
  };

  const onClaim = async () => {
    try {
      setLoading(true);

      let borrowers = await getBorrowersForLender(account);

      console.log("borrowers getBorrowersForLender ", borrowers);

      let scholarToClaimYieldOn = borrowers.filter(
        (col) =>
          col.borrowerEOA.toLowerCase() === scholarSelected.toLowerCase() &&
          col.lenderAddress.toLowerCase() === account.toLowerCase()
      );

      if (scholarToClaimYieldOn.length === 0) {
        setLoading(false);
        setSnackbar({
          open: true,
          severity: "info",
          message: `No claimed NFT found!`,
        });
        setScholarSelected("");
        return;
      }

      //count for unique reward token addresses
      const rtaCount = scholarToClaimYieldOn.filter(
        (a, i) =>
          scholarToClaimYieldOn.findIndex(
            (s) => a.rewardTokenAddress === s.rewardTokenAddress
          ) === i
      ).length;

      console.log("scholarToClaimYieldOn", { scholarToClaimYieldOn, rtaCount });

      // checking if lender is eligible for claiming yield
      const allTimestamps = scholarToClaimYieldOn.map(
        (borrower) => borrower?.inPlatformTxTimeStamp
      );
      let currentDate = Math.floor(Date.now() / 1000);
      console.log(
        "allTimestamps.some(timestamp => timestamp > currentDate)",
        allTimestamps,
        allTimestamps.every((timestamp) => timestamp > currentDate)
      );
      if (allTimestamps.every((timestamp) => timestamp > currentDate)) {
        let dayDiff = moment(allTimestamps[0] * 1000).diff(
          moment(currentDate * 1000),
          "days"
        );
        setLoading(false);
        setSnackbar({
          open: true,
          severity: "error",
          message: `Not Authorized for ${dayDiff} days`,
        });
        setScholarSelected("");
        return;
      }

      const accumulateYield = await Promise.all(
        scholarToClaimYieldOn.map(async (scy) => {
          const resp = await getAccumulatedYield(
            scy.lenderAddress,
            scy.borrowerEOA,
            scy.rewardTokenAddress
          );
          console.log("resp", resp);
          return {
            ...scy,
            resp,
          };
        })
      );

      console.log("accumulateYield", accumulateYield);

      const yieldExistedRecords = accumulateYield.filter(
        (accYield) => !accYield?.resp?.status
      );

      const uniqueYieldExistedRecords = yieldExistedRecords.filter(
        (a, i) =>
          yieldExistedRecords.findIndex(
            (s) => a.rewardTokenAddress === s.rewardTokenAddress
          ) === i
      );

      //count for unique reward token addresses
      const tokenEligibleForYieldDistributionCount =
        uniqueYieldExistedRecords.length;

      console.log("yieldExistedRecords", {
        yieldExistedRecords,
        uniqueYieldExistedRecords,
        tokenEligibleForYieldDistributionCount,
      });

      if (uniqueYieldExistedRecords.length) {
        const yieldDistribution = await Promise.all(
          await uniqueYieldExistedRecords.map((yieldExisted) => {
            return yieldDistribute(
              yieldExisted.encrptedPubKey,
              yieldExisted.borrowerEOA,
              yieldExisted.rewardTokenAddress
            );
          })
        );
        console.log("yieldDistribution FINALFINALFINAL", yieldDistribution);

        const successFullyClaimed = yieldDistribution.filter(
          (finalResp) => finalResp?.payload?.hash
        );
        const failedClaimed = yieldDistribution.filter(
          (finalResp) => !finalResp?.payload?.hash
        );

        console.log(
          "successFullyClaimed failedClaimed",
          successFullyClaimed,
          failedClaimed
        );

        if (yieldDistribution.length === successFullyClaimed.length) {
          const allHashes = successFullyClaimed.map(
            (finalResp) => finalResp?.payload?.hash
          );
          console.log("allHashes", allHashes);

          const allHashesReceipts = await Promise.all(
            await allHashes.map(async (hash, index) => {
              return await onConfirmYieldDistribution(
                hash,
                index,
                allHashes.length,
                () => {
                  setSnackbar({
                    open: true,
                    severity: "success",
                    message: `${tokenEligibleForYieldDistributionCount}/${rtaCount} Tokens' yield distributed successfully!`,
                  });
                  setLoading(false);
                }
              );
            })
          );
          console.log("allHashesReceipts", allHashesReceipts);
        } else {
          onClaimCallback(
            successFullyClaimed.length > 0
              ? `${successFullyClaimed.length}/${rtaCount} Tokens' yield distributed successfully!`
              : failedClaimed[0]?.payload?.msg || "Something went wrong!",
            false
          );
          setLoading(false);
          setScholarSelected("");
        }
      } else {
        setSnackbar({
          open: true,
          severity: "error",
          message: "No Yield Available For Claimer",
        });
        setScholarSelected("");
        setLoading(false);
      }

      // const resp = await getKeyForYieldClaim(
      //   account,
      //   "EMBER_LENDER",
      //   scholarToClaimYieldOn[0].encryptedKey
      // );
      // console.log("resp for key", resp);
      // const finalResp = await onYieldDistribution(
      //   resp,
      //   account.toLowerCase(),
      //   scholarToClaimYieldOn[0].borrowerEOA.toLowerCase(),
      //   scholarToClaimYieldOn[0].rewardTokenAddress.toLowerCase()
      // );
      // console.log("finalResp", finalResp);
      // if (finalResp?.payload?.hash) {
      //   await onConfirmYieldDistribution(
      //     finalResp?.payload?.hash,
      //     onClaimCallback
      //   );
      // } else {
      //   onClaimCallback(
      //     finalResp?.payload?.msg || "Something went wrong!",
      //     false
      //   );
      // }
    } catch (e) {
      console.log("error on claim", e);
      setLoading(false);
    }
  };

  return (
    <Box display="flex" flexDirection={"column"} width="98%">
      {view === "gallery" && (
        <Box {...NftBoxProps()}>
          {searchShow && filtered.length > 0 ? (
            filtered.map((item, index) => (
              <Box gridColumn="span 5" gridRow="span 3">
                <ScholarCard
                  profilePic={item?.profilePic}
                  coverPic={item?.coverPic}
                  name={item.scholarName}
                  address={item.scholarAddress}
                  id={item._id}
                  totalNfts={item?.totalBorrowedNfts || 0}
                  split={"24%"}
                  earnings={"$3,585"}
                  key={index}
                  scholarSelected={scholarSelected}
                  setScholarSelected={setScholarSelected}
                />
              </Box>
            ))
          ) : searchShow && filtered.length === 0 ? (
            <></>
          ) : (
            scholarsToRender.map((item, index) => (
              <Box gridColumn="span 5" gridRow="span 3">
                <ScholarCard
                  profilePic={item?.profilePic}
                  coverPic={item?.coverPic}
                  name={item.scholarName}
                  address={item.scholarAddress}
                  id={item._id}
                  totalNfts={item?.totalBorrowedNfts || 0}
                  split={"24%"}
                  earnings={"$3,585"}
                  key={index}
                  scholarSelected={scholarSelected}
                  setScholarSelected={setScholarSelected}
                />
              </Box>
            ))
          )}
          <Box gridColumn="span 5" gridRow="span 3">
            <AddScholarBox onClick={() => setOpen(true)}>
              <img src={addIcon} alt="add" />
            </AddScholarBox>
          </Box>
        </Box>
      )}

      {view === "table" && searchShow && filtered.length > 0 ? (
        <ScholarTableView
          data={filtered}
          scholarSelected={scholarSelected}
          setScholarSelected={setScholarSelected}
        />
      ) : view === "table" && searchShow && filtered.length === 0 ? (
        <></>
      ) : (
        view === "table" && (
          <ScholarTableView
            data={scholarsToRender}
            scholarSelected={scholarSelected}
            setScholarSelected={setScholarSelected}
          />
        )
      )}

      <Box
        display="flex"
        flexDirection="row"
        width="97%"
        marginBottom="10px"
        marginTop="50px"
        alignItems={"center"}
        justifyContent={"center"}
        pl={1}
      >
        <StyledButton
          onClick={async () => {
            onClaim();
          }}
          variant="outlined"
          colors={colors}
          disabled={scholarSelected.length === 0}
        >
          Claim Yield
        </StyledButton>

        {/* <StyledButton
          onClick={() => console.log("bulk send")}
          variant="outlined"
          colors={colors}
        >
          Reclaim NFTs
        </StyledButton> */}
      </Box>
    </Box>
  );
};
